(function () {
  function initQuiz(root) {
    if (!root || root.dataset.pdMeterQuizInit === 'true') return;

    var dataEl = root.querySelector('.pd-page-meter-quiz__data');
    var questionEl = root.querySelector('.pd-page-meter-quiz__question');
    var answersEl = root.querySelector('.pd-page-meter-quiz__answers');
    var contentEl = root.querySelector('.pd-page-meter-quiz__content');

    if (!dataEl || !questionEl || !answersEl || !contentEl) return;

    var quizData;
    try {
      quizData = JSON.parse((dataEl.textContent || '').trim());
    } catch (error) {
      console.error('Failed to parse meter quiz JSON:', error, root);
      return;
    }

    root.dataset.pdMeterQuizInit = 'true';

    var currentKey = quizData.start;
    var historyStack = [];

    function resolveResult(key) {
      var result = quizData.results && quizData.results[key];
      if (typeof result === 'string' && (/^\//.test(result) || /^https?:\/\//.test(result))) {
        return result;
      }
      return null;
    }

    function showQuestion() {
      var resultUrl = resolveResult(currentKey);
      if (resultUrl) {
        window.location.href = resultUrl;
        return;
      }

      var question = quizData.questions && quizData.questions[currentKey];

      if (historyStack.length > 0) {
        contentEl.classList.remove('pd-page-meter-quiz__content--animate');
        void contentEl.offsetWidth;
        contentEl.classList.add('pd-page-meter-quiz__content--animate');
      }

      if (!question) {
        questionEl.textContent = 'No result available.';
        answersEl.innerHTML = '';
        return;
      }

      questionEl.textContent = question.text;
      answersEl.innerHTML = '';

      question.answers.forEach(function (answer) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pd-page-meter-quiz__answer';
        btn.textContent = answer.text;
        btn.addEventListener('click', function () {
          var nextKey = answer.next;
          var nextResult = resolveResult(nextKey);
          if (nextResult) {
            window.location.href = nextResult;
            return;
          }

          historyStack.push(currentKey);
          currentKey = nextKey;
          showQuestion();
        });
        answersEl.appendChild(btn);
      });
    }

    showQuestion();
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-pd-page-meter-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
